import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'userManagement.3pc.noTerritories.title' }),
    button: translate({ id: 'userManagement.3pc.noTerritories.button' }),
  }))

  return api
}
